/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { PresentationQueryData } from "../../core/models/Presentation";
import NetworkServiceFactory from "../../core/services/network/NetworkService";
import { DEFAULT_QUERY_DATA } from "../../core/services/network/NetworkTypes";
import { usePresentationsContext } from "./PresentationsContext";

const usePresentationsActions = () => {
  const {
    setPresentationResponseData,
    setPresentationLoading,
    setPresentationError,
    setSelectedPresentation,
  } = usePresentationsContext();

  const dispatchGetPresentations = async (
    query: PresentationQueryData = DEFAULT_QUERY_DATA()
  ) => {
    const networkService = NetworkServiceFactory.shared;
    try {
      setPresentationLoading(true);
      const data = await networkService.getPresentations(query);
      setPresentationResponseData(data);
      setPresentationError(undefined);
      return data;
    } catch (e: any) {
      setPresentationError(e);
    } finally {
      setPresentationLoading(false);
    }
  };
  const dispatchGetPresentation = async (query: string) => {
    const networkService = NetworkServiceFactory.shared;
    try {
      const data = await networkService.getPresentation(query);
      setSelectedPresentation(data);
      setPresentationError(undefined);
      return data;
    } catch (e: any) {
      setPresentationError(e);
    } finally {
      setPresentationLoading(false);
    }
  };

  const dispatchCleanPresentationsContext = () => {
    setPresentationResponseData(undefined);
    setPresentationError();
  };

  return {
    dispatchGetPresentations,
    dispatchGetPresentation,
    dispatchCleanPresentationsContext,
  };
};

export { usePresentationsActions };
